export default __webpack_public_path__ + "static/media/ethereum-logo.3fd259e9.svg";